import React from "react";
import {
  Button,
  CircularProgress,
  Modal,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteModal = ({ loading, open, setOpen, handleDeletefunction, id }) => {
  const handleClose = () => setOpen(false);

  const handleDelete = () => handleDeletefunction(id);

  return (
    <Modal
      open={open}
      BackdropProps={{
        style: {
          backgroundColor: "transparent",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 360,
          bgcolor: "#fff",
          borderRadius: 2,
          border: "2px solid rgba(29, 57, 105, 1)",
          //   boxShadow: 24,
          p: 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography id="delete-modal-title" variant="h6">
            Confirm Deletion
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Typography
          id="delete-modal-description"
          sx={{ mt: 2, color: "text.secondary" }}
        >
          Are you sure you want to delete this item? This action cannot be
          undone.
        </Typography>

        {/* Actions */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            disableElevation
            sx={{ minWidth: 100 }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
